<template>
  <div>
    <form @submit.prevent="sendFormData">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label class="form-label">Munka megnevezése:</label>
            <input
              type="text"
              class="form-control"
              v-model="form_data.task_name"
              disabled
            />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Munka jellege:</label>
            <select
              class="form-select border-warning"
              v-model="form_data.work_type"
            >
              <option
                :value="item.id"
                v-for="(item, id) in responsible_departments"
                :key="id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Kivitelező cég:</label>
            <select class="form-select" v-model="form_data.partner_id" disabled>
              <option
                v-for="(partner, id) in partners"
                :key="id"
                :value="partner.id"
              >
                {{ partner.name }}
              </option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Munkahelyi vezetőjének neve:</label>
            <select class="form-select" v-model="form_data.partner_worker_id">
              <option
                v-for="(worker, id) in chosenPartnerWorkers"
                :key="id"
                :value="worker.id"
              >
                {{ worker.name }}
              </option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Telefonszáma:</label>
            <input
              type="text"
              class="form-control"
              v-model="form_data.partner_worker_tel"
              :readonly="form_data['has_phone_partner_worker_tel']"
            />
          </div>
          <label class="form-label"
            >Ez az engedély a következő dátumtól érvényes:</label
          >
          <div class="row">
            <div class="col-md-8">
              <div class="form-group mt-2">
                <input
                  type="date"
                  class="form-control border-warning"
                  v-model="start_date"
                  :min="start_date"                  
                  :max="end_date"                  
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mt-2">
                <input
                  v-if="form_data.with_time"
                  type="time"
                  class="form-control border-warning"
                  v-model="start_time"
                  
                />
              </div>
            </div>
          </div>
          <label class="form-label"
            >Ez az engedély a következő dátumig érvényes:</label
          >
          <div class="row">
            <div class="col-md-8">
              <div class="form-group mt-2">
                <input
                  type="date"
                  class="form-control border-warning"
                  v-model="end_date"
                  :min="start_date"
                  :max="end_date"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mt-2">
                <input
                  v-if="form_data.with_time"
                  type="time"
                  class="form-control border-warning"
                  v-model="end_time"
                  
                />
              </div>
            </div>
          </div>
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              :true-value="false"
              :false-value="true"
              type="checkbox"
              v-model="form_data.with_time"
              id="with_time_input"
              
            />
            <label class="form-check-label" for="with_time_input"
              >Egész nap</label
            >
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Munkaterület igény meghatározása:</label>
            <textarea
              class="form-control border-warning"
              cols="30"
              rows="10"
              v-model="form_data.place_needs"
            ></textarea>
          </div>
          <div class="form-group mb-3" v-if="task.description">
            <label class="form-label">Kiegészítő információk:</label>
            <div class="d-block mt-2">{{ task.description }}</div>
          </div>
          <div class="form group mb-3">
            <label class="form-label"
              >A munkafolyamat során a következő engedélyek kitöltése kötelező a
              vállalkozó cég vezetője által:</label
            >
            <div
              class="input-group mb-10px"
              v-for="permit in external_permits"
              :key="permit.id"
            >
              <div class="input-group-text">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :value="permit.id"
                  v-model="form_data.external_permits"
                />
              </div>
              <span class="input-group-text">
                {{ permit.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div v-if="permit_type.coordination != 1">
            <!-- coordination -->
            <div class="form-group mb-3">
              <label class="form-label">Összehangolást végző cég:</label>
              <select class="form-select" v-model="form_data.lead_partner_id">
                <option
                  v-for="(partner, id) in partnersWithDDC"
                  :key="id"
                  :value="partner.id"
                >
                  {{ partner.name }}
                </option>
              </select>
            </div>
            <div class="form-group my-3">
              <label class="form-label">Összehangoló személy neve:</label>
              <select class="form-select" v-model="form_data.lead_user_id">
                <option
                  v-for="(worker, id) in coordinationUsers"
                  :key="id"
                  :value="worker.id"
                >
                  {{ worker.name }}
                </option>
              </select>
              <!-- vállalkozó -->
            </div>
            <div class="form-group mb-3">
              <label class="form-label">Telefonszáma:</label>
              <input
                type="text"
                class="form-control"
                v-model="form_data.lead_user_tel"
                :readonly="form_data['has_phone_lead_user_tel']"
              />
            </div>
          </div>
          <!-- end of coordination -->
          <div class="form-group mb-3">
            <!-- A munkaterület biztonságos állapotban van, <input type="text" v-model="form_data.method" class="form-control d-inline-block w-150px border-warning"> módszerrel körülhatároltam és megjelöltem -->
            <div class="form-check">
              <input
                type="radio"
                class="form-check-input border-warning"
                :value="1"
                v-model="form_data.method"
              />
              <label
                >A munkaterület biztonságos állapotban van, fizikai módszerrel
                körülhatároltam és megjelöltem</label
              >
            </div>
            <div class="form-check mt-1">
              <input
                type="radio"
                class="form-check-input border-warning"
                :value="2"
                v-model="form_data.method"
              />
              <label
                >A munkaterület biztonságos állapotban, a körülhatárolása a
                terület átadásakor nem szükséges.</label
              >
            </div>
          </div>
          <div class="form-group mb-3">
            A munkaterület átadásával egyidejűleg ismertetésre került a
            megrendelő „Duna-Dráva Cement Kft. Beremendi Gyár általános, munka-,
            tűz- és környezetvédelmi feltételrendszere”, valamint az átadott
            munkaterületen, valamint a munkavégzés során kötelezően alkalmazandó
            előírások, úgy mint:
            <ul>
              <li>Viselkedési, magatartási szabályok</li>
              <li>Közlekedési előírások</li>
              <li>Teendők baleset, tűz keletkezése, észlelése során</li>
              <li>Munkavégzés hétvégén, ünnepnapokon</li>
              <li>
                Egyéb:
                <input
                  type="text"
                  class="form-control"
                  v-model="form_data.other"
                />
              </li>
            </ul>
          </div>
          <div class="form-group mb-3">
            A vállalkozó cég által használható energiaforrások megjelölése.
            Vállalkozó cég részére használatra átadott munkaeszköz a
            szerződésben rögzítettek alapján
            <div
              class="input-group mb-10px"
              v-for="(item, id) in items.resources"
              :key="id"
            >
              <div class="input-group-text">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form_data.resources[item.id].value"
                />
              </div>
              <span class="input-group-text">
                {{ item.name }}
              </span>
              <input
                v-if="item.with_text && form_data.resources[item.id].value"
                type="text"
                v-model="form_data.resources[item.id].text"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group mb-3">
            <label class="form-label"
              >A vállalkozó cég által használható szociális létesítmények a
              szerződésben rögzítettek alapján:</label
            >
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="form_data.dresser"
              />
              <label class="form-check-label">Öltöző</label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="form_data.wc"
              />
              <label class="form-check-label">WC</label>
            </div>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Speciális tudnivalók:</label>
            <textarea
              class="form-control"
              cols="30"
              rows="10"
              v-model="form_data.special_good_to_know"
            ></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import User from "../../apis/User";
import Partner from "../../apis/Partner";
import Task from "../../apis/Task";
import moment from "moment";
import Confirmation from "../../apis/Confirmation";
export default {
  props: { permit_type: Object, task: Object },
  data() {
    return {
      permit: {},
      coordinationUsers: [],
      form_data: {
        task_name: this.task.name,
        work_type: "",
        partner_id: this.task.partner_id,
        partner_worker_id: this.task.partner_user_id,
        partner_worker_tel: "",
        lead_partner_id: this.permit_type.coordination_partner_id,
        lead_user_id: this.permit_type.coordination_user_id,
        lead_user_tel: "",
        ddc_user_id: this.task.ddc_user_id,
        start_date_time: null,
        end_date_time: null,
        production_on_site: false,
        location_lead_id: this.task.ddc_user_id,
        special_good_to_know: null,
        place_needs: "",
        wc: false,
        dresser: false,
        resources: [
          { value: false, text: null },
          { value: false, text: null },
          { value: false, text: null },
          { value: false, text: null },
          { value: false, text: null },
          { value: false, text: null },
          { value: false, text: null },
        ],
        with_time: true,
        other: null,
        external_permits: [],
      },
      ddc_users: [],
      partner_workers: [],
      chosenPartnerWorkers: [],
      location_leads: [],
      partners: [],
      items: false,
      completition_items: false,
      responsible_departments: false,
      permit_types: false,
      external_permits: [],
      start_date: JSON.parse(this.task.additional).start_date,
      start_time: JSON.parse(this.task.additional).start_time,
      end_date: JSON.parse(this.task.additional).end_date,
      end_time: JSON.parse(this.task.additional).end_time,
      now: moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    is_complete() {
      if (
        this.completition_items.filter((ci) => ci.satisfied == false).length ==
          0 &&
        this.datetime_complete
      ) {
        return true;
      } else {
        return false;
      }
    },
    datetime_complete() {
      if (this.start_date && this.end_date) {
        if (this.form_data.with_time) {
          if (this.start_time && this.end_time) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    partnersWithDDC() {
      return [{ id: null, name: "DDC" }, ...this.partners];
    },
  },
  watch: {
    form_data: {
      handler() {
        this.completition_items.forEach((ci) => {
          switch (ci.type) {
            case 1:
              if (
                this.form_data[ci.name].filter((i) => i.value == true).length >=
                1
              ) {
                this.$set(ci, "satisfied", true);
              } else {
                this.$set(ci, "satisfied", false);
              }
              break;
            case 2:
              if (this.form_data[ci.name]) {
                this.$set(ci, "satisfied", true);
              } else {
                this.$set(ci, "satisfied", false);
              }
              break;
          }
        });
      },
      deep: true,
    },
    "form_data.lead_partner_id": function () {
      this.setCoordinationUsers();
      this.setUserPhone(this.form_data, "lead_user_tel", null);
    },
    "form_data.lead_user_id": function (val) {
      if (val) {
        this.setUserPhone(this.form_data, "lead_user_tel", val);
      }
    },
    "form_data.partner_worker_id": function (val) {
      if (val) {
        this.setUserPhone(this.form_data, "partner_worker_tel", val);
      }
    },
  },
  created() {
    if (this.permit_type.start_date_time) {
      let start_moment = moment(this.permit_type.start_date_time);
      this.start_date = start_moment.format("YYYY-MM-DD");
      this.start_time = start_moment.format("HH:mm");
    }
    if (this.permit_type.end_date_time) {
      let end_moment = moment(this.permit_type.end_date_time);
      this.end_date = end_moment.format("YYYY-MM-DD");
      this.end_time = end_moment.format("HH:mm");
    }
    //this.form_data.task_name = this.task.name,
    //Task.getPermitForm(this.task.id,this.permit_type.id)
    //.then(response => {
    //	if(response.data){
    //	this.form_data = response.data
    //}
    //});
    if (this.permit_type.form_data) {
      this.form_data = this.permit_type.form_data;
    }
    Partner.index().then((response) => {
      this.partners = response.data;
    });
    User.getRole(6)
      .then((response) => {
        if (response.data.length != 0) {
          this.partner_workers = response.data;
          this.chosenPartnerWorkers = this.partner_workers.filter(
            (item) => item.partner_id == this.task.partner_id
          );
        } else {
          this.partner_workers = response.data;
        }
      })
      .then(() => {
        this.setCoordinationUsers();
      });
    User.getRole(10)
      .then((response) => {
        this.ddc_users = response.data;
      })
      .then(() => {
        this.setCoordinationUsers();
      });
    User.getRole(3).then((response) => {
      this.location_leads = response.data;
    });

    this.setUserPhone(
      this.form_data,
      "lead_user_tel",
      this.form_data.lead_user_id
    );
    this.setUserPhone(
      this.form_data,
      "partner_worker_tel",
      this.form_data.partner_worker_id
    );

    this.responsible_departments = JSON.parse(
      localStorage.getItem("constants")
    ).responsible_departments.filter((rd) => rd.show_at_task == true);

    this.items = JSON.parse(
      localStorage.getItem("constants")
    ).permit_types.find((pt) => pt.id == this.permit_type.permit_type).items;

    this.completition_items = JSON.parse(
      localStorage.getItem("constants")
    ).permit_types.find(
      (pt) => pt.id == this.permit_type.permit_type
    ).completition_items;

    this.permit_types = JSON.parse(
      localStorage.getItem("constants")
    ).permit_types;

    this.external_permits = JSON.parse(
      localStorage.getItem("constants")
    ).external_permits;
  },
  methods: {
    sendFormData() {
      if (!this.is_complete) {
        Confirmation.swalCustomConfirm(
          "Hiányos kitöltés",
          "Mentés mindenképp",
          "Így az engedély nem lesz kitöltött állapotú, a mégsem gombra kattintva folytathatod a kitöltést"
        ).then((response) => {
          if (response.isConfirmed === true) {
            this.submitForm();
          } else {
            this.$emit("loadingstop");
          }
        });
      } else {
        this.submitForm();
      }
    },
    submitForm() {
      let start_date_time = this.start_date
        ? moment(
            this.start_date +
              (this.start_time && this.form_data.with_time
                ? " " + this.start_time
                : " 00:00")
          )
            .tz("Europe/Budapest")
            .format()
        : this.start_date;
      let end_date_time = this.end_date
        ? moment(
            this.end_date +
              (this.end_time && this.form_data.with_time
                ? " " + this.end_time
                : " 23:59")
          )
            .tz("Europe/Budapest")
            .format()
        : this.end_date;
      Task.sendPermitForm(this.task.id, this.permit_type.id, {
        form_data: this.form_data,
        is_complete: this.is_complete,
        start_date_time: start_date_time,
        end_date_time: end_date_time,
      }).then(() => {
        this.$emit("closemodal");
      });
    },
    setCoordinationUsers() {
      if (!this.form_data.lead_partner_id) {
        this.coordinationUsers = this.ddc_users.filter(
          (item) => item.roles.includes(3) || item.roles.includes(5)
        );
      } else {
        this.coordinationUsers = this.partner_workers.filter(
          (item) => item.partner_id == this.form_data.lead_partner_id
        );
      }
    },
    setUserPhone(refObject, refObjectProperty, userId) {
      if (!userId) {
        refObject["has_phone_" + refObjectProperty] = false;
        refObject[refObjectProperty] = "";
        return;
      }

      User.show(userId).then((response) => {
        if (response.data.phone == null) {
          refObject["has_phone_" + refObjectProperty] = false;
          refObject[refObjectProperty] = "";
          return;
        }
        refObject["has_phone_" + refObjectProperty] = true;
        refObject[refObjectProperty] = response.data.phone;
      });
    },
  },
};
</script>
